import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, inject } from '@angular/core';
import {IonRefresher,IonRefresherContent,RefresherCustomEvent,} from '@ionic/angular/standalone';
import { LodgeStateService } from '../../services/lodge-state.service';
import { SettingsStateService } from '../../services/settings-state.service';

@Component({
  selector: 'app-page-refresher',
  standalone: true,
  imports: [CommonModule, IonRefresher, IonRefresherContent],
  template: `
    <ion-refresher *ngIf="isMobile" slot="fixed" (ionRefresh)="refreshPage($event)">
      <ion-refresher-content
        pullingIcon="chevron-down-circle-outline"
        refreshingSpinner="crescent">
      </ion-refresher-content>
    </ion-refresher>
  `,
})
export class PageRefresherComponent {
  @Output() refreshed = new EventEmitter<void>();

  private lodgeState = inject(LodgeStateService);
  private settingsState = inject(SettingsStateService);

  get isMobile(): boolean {
    return window.innerWidth < 900;
  }

  async refreshPage(event: RefresherCustomEvent): Promise<void> {
    try {
      await Promise.all([
        this.lodgeState.refreshAll(true),
        this.settingsState.refreshSettings(true),
      ]);
      this.refreshed.emit();
    } finally {
      event.target.complete();
    }
  }
}
